import { FileButton as MantineFileButton } from "@mantine/core";
import { forwardRef } from "react";

import { showErrorToast } from "#app/notifications";
import { Button, ButtonProps } from "#shared/view/designSystem/Button";

type Props = {
  onChange?: (payload: { id?: string; name: string; data: File }[]) => void;
  buttonVariant: ButtonProps["variant"];
  buttonLabel: string;
  buttonIcon?: ButtonProps["icon"];
  loading?: boolean;
};

const MAX_SIZE = 5 * 100 * 1000000; // 500 Mo

export const PartFileButton = forwardRef<HTMLButtonElement, Props>(
  ({ onChange, buttonVariant, buttonLabel, buttonIcon, loading }, ref) => {
    const handleChange = (payload: File[]) => {
      if (payload.length > 0) {
        const uploadablePayload: { name: string; data: File }[] = [];

        if (payload instanceof File) {
          if (payload.size > MAX_SIZE) {
            showErrorToast({
              title: "Erreur lors du choix du fichier",
              message: "Le fichier ne peut pas excéder 500 Mo",
            });

            return;
          }

          uploadablePayload.push({ name: payload.name, data: payload });
        } else {
          payload.forEach((file) => {
            if (file.size > MAX_SIZE) {
              showErrorToast({
                title: "Erreur lors du choix des fichiers",
                message: "Un fichier excéde 500 Mo",
              });

              return undefined;
            }

            return uploadablePayload.push({
              name: file.name,
              data: file,
            });
          });
        }

        onChange?.(uploadablePayload);
      }
    };

    return (
      <MantineFileButton onChange={handleChange} multiple>
        {(props) => (
          <Button variant={buttonVariant} icon={buttonIcon} ref={ref} loading={loading} {...props}>
            {buttonLabel}
          </Button>
        )}
      </MantineFileButton>
    );
  },
);
